





















import { Component, Mixins } from 'vue-property-decorator'
import BasePage from '@/tcw/components/BasePage'
import TcwLayoutBasicTemplate from '@/layout/TcwLayoutBasicTemplate.vue'
import UserListTable from '@/components/user/organisms/UserListTable.vue'

@Component({
  components: { TcwLayoutBasicTemplate, UserListTable }
})
export default class UserListPage extends Mixins(BasePage) {
  private registUser(): void {
    this.$router.push(`/user/create`)
  }
}
